import { useRef, useState } from 'react';
import ScrappingByRefForm from './ScrappingByRefForm';
import ResultsList from './components/ResultsList';
import SearchProgress from './components/SearchProgress';
import { toast } from 'react-toastify';
import { SCRAPPER_API } from '../../../../../../../../../../../shared/services/scrapping';
import { checkIfIsReliableProveedor, setErrorMessage } from '../../../../../../../../../../../shared/helpers/functionalities';
import { INTEGRACIONES_API } from '../../../../../../../../../../../shared/services/piezas';
import { useDispatch, useSelector } from 'react-redux';
import { obtainCats } from '../../../../../../../../../../../../../../utils/categoriasmap';
import { PROVEEDORES_API } from '../../../../../../../../../../../shared/services/proveedores';
import Loading from '../../../../../../../../../../../shared/components/Loading';
import ProveedorPocoFiableModal from '../ProveedorPocoFiableModal';
export default function PartSearcher({
    onSelectedPart
}) {
    const [parts, setParts] = useState([]);
    const [marketPlacesParts, setMarketPlacesParts] = useState([]);
    const [showPartsList, setShowPartsList] = useState(false);
    const [showUnreliableModal, setShowUnreliableModal] = useState(false);
    const [partInfo, setPartInfo] = useState([]);
    const [showForm, setShowForm] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const marketPlacesToSearch = useRef(null);
    const dispatch = useDispatch();

    const tipoPiezas = useSelector(state => {
        const { tipo_piezas } = state;
        return tipo_piezas;
    });
    const marcas = useSelector(state => {
        const { marcas } = state;
        return marcas;
    });
    const modelos = useSelector(state => {
        const { modelos } = state;
        return modelos;
    });
    const piezasNoGarantia = [
        61, 226, 230, 233, 234,
        235, 236, 237, 238,
        239, 240, 241, 242,
        243, 244, 245, 246,
        247, 248, 249, 251, 261,
        265, 266, 267, 450
    ];

    const getTipo = (tipo) => {
        const cats = obtainCats()
        let id = cats.find(tp => tp.nombre.toLowerCase() ===  tipo.toLowerCase())?.idcrm;
        if (!id){
            id = tipoPiezas.find(tp => tp.nombre.toLowerCase() ===  tipo.toLowerCase())?.id;
        }
        return id
    }

    const getMarca = (marca) => { return marcas.find(m => m.nombre.toLowerCase() ===  marca.toLowerCase())?.id; }

    const getModelo = (modelo) => {
        modelo = modelo.split(' ')[0];
        return modelos.find(m => m.nombre.toLowerCase()?.includes(modelo.toLowerCase()))?.id; 
    }

    const handleSearch = async (data) => {
        setIsLoading(true);
        setParts([]);
        setMarketPlacesParts([]);
        setShowForm(false);
        const ref = data.ref;
        const selectedMarketPlaces = data.marketPlaces;

        if (selectedMarketPlaces.length > 0) {
            handleScraperSearch(selectedMarketPlaces, ref);

            marketPlacesToSearch.current = selectedMarketPlaces.map((marketPlace) => {
                return {
                    name: marketPlace,
                    received: false,
                };
            });
        }

        data.referencia_pieza = ref;

        const resultsResponse = await INTEGRACIONES_API.getPiezas(data, 1);

        if (selectedMarketPlaces.length === 0) {
            setIsLoading(false);
            setShowPartsList(true);
        }

        if(resultsResponse && resultsResponse.success) {
            setParts(mapIntegrationParts(resultsResponse.data.piezas, ref));
        }
    }

    const mapIntegrationParts = (parts, ref) => {
        parts.forEach((part) => {
            part['Año'] = part.anopieza;
            part.isFromIntegration = true;
            part.ref_vendedor = part.id_original;
            part.vendedor = part.origen;
            part.images = part.imgs;
            part.pieza = part.nombre;
            part.observaciones = part.notapublica;
            part['Versión'] = part.modelo;
            part.marketPlace = 'Integración';
            part.url = 'integracion-desguace-' + part.vendedor;
            part.marca_id = getMarca(part.marca);
            part.modelo_id = getModelo(part.modelo);
            part.nombre = part.pieza + ' ' + part.marca + ' ' + part.modelo;
            part.referencia_pieza = ref;
            part.id_referencia_plataforma = part.id_desguace;
            part.precio_original = parseInt(part.precio) === 0 ? '0.01' : parseFloat(part.precio).toFixed(2);
            part.precio_compra = parseInt(part.precio) === 0 ? '0.01' : parseFloat(part.precio).toFixed(2);
            part.casco = 0;
            part.disponible = part.ubicacion.toLowerCase().includes('montada') ? null : 1;
            part.integracion = true;
            part.pieza_integracion_id = part.id;
            part.modelo = null;
            part.marca = null;
            part.imgsUrl = part?.imgs;
        });

        return parts;
    }

    const handleScraperSearch = async(marketplaces, ref) => {
        try {
            const res = await SCRAPPER_API.scrappingRef(marketplaces, ref)
            if(res?.success) {
                const data = res.data;
                let newArr = [];
                Object.keys(data).forEach(marketplace => {
                    const arr = sortParts(data, marketplace);
                    newArr = [...newArr, ...arr];
                });
                marketPlacesToSearch.current = null;
                setMarketPlacesParts(newArr);
            }
        } catch (e) {
            toast.error(e.message);
        } finally {
            setIsLoading(false)
            setShowPartsList(true)
        }

    }

    const sortParts = (data, marketPlace) => {
        let newParts = [];

        if (marketPlace === 'recambiofacil') {
            newParts = sortRecambioFacilParts(data[marketPlace], marketPlace);
            showNewResultsMessage(marketPlace, newParts);

            return newParts;
        }

        newParts = data[marketPlace];
        newParts.forEach(part => addPropertiesToPart(part, marketPlace));
        showNewResultsMessage(marketPlace, newParts);

        return sortPartsByPrice(newParts);
    }

    const sortRecambioFacilParts = (parts, marketPlace) => {
        const catParts = parts.cat;
        catParts?.forEach(part => addPropertiesToPart(part, marketPlace, 'cat'));

        const iamParts = parts.iam;
        iamParts?.forEach(part => addPropertiesToPart(part, marketPlace, 'iam'));

        const oemParts = parts.oem;
        oemParts?.forEach(part => addPropertiesToPart(part, marketPlace, 'oem'));

        parts = [...catParts, ...iamParts, ...oemParts];

        return sortPartsByPrice(parts);
    }

    const sortPartsByPrice = (parts) => parts.sort((a, b) => parseInt(a.precio) - parseInt(b.precio));

    const addPropertiesToPart = (part, marketPlace, type = '') => {
        part.marketPlace = marketPlace;
        part.type = type;
    };

    const showNewResultsMessage = (marketPlace, newParts) => {
        marketPlacesToSearch.current = marketPlacesToSearch.current.map((web) => {
            if (web.name === marketPlace) {
                web.received = true;
            }

            return web;
        });
    }

    const handleScrapping = (confirm) => {
        if (confirm) {
            onSelectedPart(partInfo);
        } /*else {
            setPartInfo([]);
            setShowUnreliableModal(false);
        }*/
    }

    const handleSelectIntegrationPart = async (part) => {
        const proveedorResult = await PROVEEDORES_API.getIntegrationProvider({
            id_crm: part.id_crm,
            nombre_origen: part.origen
        });

        const proveedor = await proveedorResult.data;
        const tipo = getTipo(part.nombre);

        let precioTransporte = 0;
        let garantiaId = null;

        if(tipo === 406) { precioTransporte = 80 }
        else if(tipo === 55)  { precioTransporte = 40 }
        else {
            if(tipo === 80 || tipo === 94 || tipo === 172 || (tipo >= 146 && tipo <= 151) ||
                (tipo >= 174 && tipo <= 176) || tipo === 184 ||
                (tipo === 70 || tipo === 71 || tipo === 1083 || tipo === 1733) || 
                (tipo >= 219 && tipo <= 223) ||
                (tipo === 96 || tipo === 179 || tipo === 1519)
            ) {
                if(tipo === 80 && proveedor.envio_capot !== null) {
                    precioTransporte = proveedor.envio_capot;
                } else if((tipo >= 146 && tipo <= 151)  && proveedor.envio_puertas !== null) {
                    precioTransporte = proveedor.envio_puertas;
                } else if((tipo >= 174 && tipo <= 176) && proveedor.envio_porton !== null) { 
                    precioTransporte = proveedor.envio_porton;
                } else if((tipo === 94 || tipo === 172) && proveedor.envio_paragolpes !== null) {
                    precioTransporte = proveedor.envio_paragolpes;
                } else if((tipo === 70 || tipo === 71 || tipo === 1083 || tipo === 1733) && proveedor.envio_aleta !== null) {
                    precioTransporte = proveedor.envio_aleta;
                } else if((tipo >= 219 && tipo <= 223) && proveedor.envio_transmision !== null) { 
                    precioTransporte = proveedor.envio_transmision;
                } else if((tipo === 96 || tipo === 179 || tipo === 1519) && proveedor.envio_refuerzo_paragolpes !== null) {
                    precioTransporte = proveedor.envio_refuerzo_paragolpes;
                }
            }
        }

        garantiaId = piezasNoGarantia.find(tp => tp === tipo)
            ? 5
            :  proveedor.tipo_garantia_id ? proveedor.tipo_garantia_id : 1;

        part.precio_transporte = precioTransporte;
        part.tipo_pieza_id = getTipo(part.pieza);
        part.tipo_garantia_id = garantiaId;
        part.con_descuento = part.proveedor.descuentos?.length > 0 ? true : false;

        setPartInfo(part);

        if (part?.proveedor && !checkIfIsReliableProveedor(part?.proveedor)) {
            setShowUnreliableModal(true);
            return;
        }

        onSelectedPart(part);
    }

    const handleSelectedPart = async (part) => {
        try {
            dispatch({ type: 'loading/set', payload: true });
            
            if (part.marketPlace === 'Integración') {
                await handleSelectIntegrationPart(part);
                return;
            }
    
            const response = await SCRAPPER_API.completeScrappingInfo(part)
                .catch((error) => {
                    toast.error(setErrorMessage(error || "Error! Ha ocurrido un problema al obtener toda la información de la pieza."));
                });
    
            if (response && response.success) {
                const partData = {...response.data, imgsUrl: part.images};
    
                if (!partData) {
                    return;
                }
    
                setPartInfo(partData)
    
                if (partData?.proveedor && !checkIfIsReliableProveedor(partData?.proveedor)) {
                    setShowUnreliableModal(true);
                    return;
                }
    
                onSelectedPart(partData);
            }
        } catch (error) {
            toast.error(error.message)
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    }

    const searchAgain = () => {
        setShowPartsList(false);
        setShowUnreliableModal(false);
        setShowForm(true);
    }

    return (
        <>
            { (isLoading) && <Loading /> }
            { (showForm && !isLoading) &&
                <ScrappingByRefForm
                    onSearch={handleSearch}
                    onSelectedPart={handleSelectedPart}
                />
            }

            { marketPlacesToSearch?.current &&
                <SearchProgress marketPlacesToSearch={marketPlacesToSearch.current} />
            }

            { showPartsList &&
                <>
                    <div className={'d-flex justify-content-end'}>
                        <button className={'btn btn-primary'} onClick={searchAgain}>Repetir búsqueda</button>
                    </div>
                    <ResultsList
                        results={[...parts, ...marketPlacesParts]}
                        onSelectedPart={handleSelectedPart}
                    />
                </>
            }

            { showUnreliableModal &&
                <ProveedorPocoFiableModal
                    pieza={partInfo}
                    onConfirmAction={handleScrapping} 
                    state={showUnreliableModal}>
                </ProveedorPocoFiableModal>
            }
        </>
    )
}